import { SURVEYS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(SURVEYS_ENDPOINT);
export default instance;
